export default __webpack_public_path__ + "static/media/payments-icon.43c81f36.svg";